import type { OrderType } from "sdk/types/orders";

export enum LineStyle {
  Solid = 0,
  Dotted = 1,
  Dashed = 2,
}

export type StaticChartLine = {
  id?: string;
  price: number;
  title: string;
  quantity?: string;
  lineColor?: string;
  quantityTextColor?: string;
  quantityBackgroundColor?: string;
  quantityBorderColor?: string;
};

export type DynamicChartLine = {
  id: string;
  price: number;
  orderType: OrderType;
  isLong: boolean;
  marketName: string;
};
